import { render, staticRenderFns } from "./ReactMountVendaRapida.vue?vue&type=template&id=d7a2e11c"
import script from "./ReactMountVendaRapida.vue?vue&type=script&lang=ts"
export * from "./ReactMountVendaRapida.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7a2e11c')) {
      api.createRecord('d7a2e11c', component.options)
    } else {
      api.reload('d7a2e11c', component.options)
    }
    module.hot.accept("./ReactMountVendaRapida.vue?vue&type=template&id=d7a2e11c", function () {
      api.rerender('d7a2e11c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/ReactMountVendaRapida.vue"
export default component.exports